export default __webpack_public_path__ + "static/media/undraw_tweetstorm_re_n0rs 1.8c3a187a.svg";